"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _qs = _interopRequireDefault(require("qs"));
var _index = _interopRequireDefault(require("../index"));
var version = "v1";
var _default = exports["default"] = {
  createToken: function createToken(email, token) {
    var payload = _qs["default"].stringify({
      email: email
    });
    var options = {
      headers: {
        Authorization: "Bearer ".concat(token)
      }
    };
    return _index["default"].post("/".concat(version, "/auth/username/verification/create_token"), payload, options);
  },
  verifyAccount: function verifyAccount(token) {
    var options = {
      headers: {
        Authorization: "Bearer ".concat(token)
      }
    };
    return _index["default"].post("/".concat(version, "/auth/username/verification/check_token"), "", options);
  }
};